import RecentlyVisited from './RecentlyVisited';

export default RecentlyVisited;
